import styles from './Footer.module.scss';
import {Link, Socials} from "../../components";

export const Footer = () => {
    return (
        <footer className={styles.footer}>
            <h3 className="h3">Киберкринж</h3>
            <div className={styles.info}>
                <div>Совместный спецпроект телеканала 2x2 и Kaspersky © 2022</div>
                <div>Важные ссылки: <Link text='Правила конкурса' className='' link='/action/kaspersky_vs_cybercringe/rules_cybercringe.pdf'/></div>
                <div>Pb3XmBtzsyhYT6ibjYFZ9oDk9RcUymhqxB7B736</div>
            </div>
            <Socials className="footer" footer={true}/>
        </footer>
    )
}